import React from 'react';
import Typography from '@material-ui/core/Typography';
import OrderCard from '@components/OrderCard/OrderCard';
import BottomButtonGroup from '../BottomButtonGroup';
import { useStyles, useStylesPayButton } from './styles';
import { useTranslation } from 'react-i18next';

const OrdersList = ({ order, totalPrice, handleOrder, open, handleClose }) => {
  const classes = useStyles();
  const classesPayButton = useStylesPayButton();
  const { t } = useTranslation('ordersScreen');

  return (
    <div className={classes.MainContainer}>
      <div className={classes.OrderSection}>
        <Typography variant="h4" className={classes.MainHeading}>
          {t('title')}
        </Typography>
        <span className={classes.Divider} />
        {order.map(item => (
          <OrderCard key={item.id} order={item} />
        ))}
      </div>
      <BottomButtonGroup
        totalPrice={totalPrice.toFixed(2)}
        isDisabledPayButton={false}
        classesPayButton={classesPayButton}
        handleClickPayButton={handleOrder}
      />
    </div>
  );
};

export default OrdersList;
